/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DestroyerService extends Subject<null> implements OnDestroy {
  ngOnDestroy(): void {
    this.next(null);
    this.complete();
  }
}
